import React, { Component } from 'react';
import RUTransportsWADTable from './RUTransportsWADTable';


export class RUTransportsWADContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  render() {

    return (
      <div>
        {this.state.content === 'ruTransportsWaitingArrival' ?
          <RUTransportsWADTable handleChangeContent={this.props.handleChangeContent.bind(this)} />
          : null
        }
      </div>
    )

  }
}

export default RUTransportsWADContent;


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsWaitingArrival/RUTransportsWADContent.js